import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSitemap, faUmbrellaBeach, faUsers } from "@fortawesome/free-solid-svg-icons";
import { Card, CardBody } from "reactstrap";
import { INSTALL_PATH } from "../../../Integrations/HiBob/messages";
import { BrandTile, StatusBadge } from "./Header";

const BENEFITS = [
	{ icon: faUsers, key: "hibob-benefit-people" },
	{ icon: faSitemap, key: "hibob-benefit-org" },
	{ icon: faUmbrellaBeach, key: "hibob-benefit-timeoff" },
];

function EmptyState() {
	const { t } = useTranslation();
	return (
		<Card data-testid="hibob-empty-state">
			<CardBody className="py-5 px-4">
				<div className="mx-auto" style={{ maxWidth: 560 }}>
					<div className="d-flex align-items-center flex-wrap">
						<BrandTile />
						<h1 className="h2 mb-0 ml-3 mr-3">{t("hibob-empty-title")}</h1>
						<StatusBadge status="not_connected" />
					</div>
					<p className="hibob-muted mt-3 mb-0">{t("hibob-subtitle")}</p>
					<ul className="hibob-benefits">
						{BENEFITS.map(({ icon, key }) => (
							<li key={key}>
								<FontAwesomeIcon icon={icon} fixedWidth aria-hidden="true" />
								<span>{t(key)}</span>
							</li>
						))}
					</ul>
					<Link className="btn btn-primary" to={INSTALL_PATH}>
						{t("hibob-connect")}
					</Link>
					<p className="hibob-muted text-sm mt-2 mb-0">{t("hibob-empty-note")}</p>
				</div>
			</CardBody>
		</Card>
	);
}

export default EmptyState;
